<template>
<div id="projectusers" v-cloak>

    <div v-if="isBusy"> <p> <b-spinner></b-spinner> </p>  </div>

    <div v-if="!isBusy && !dataError">
    <b-card class="text-left" header-tag="header" bg-variant="light">
        <h5 slot="header">Project Users <span style="float: right;"> <b-button variant="outline-dark"  size="sm" @click="showModal">+ Add User</b-button> </span></h5>

        <div id="userstable">
          <b-table
            ref="usersTable"
            selectable
            select-mode="single"
            thead-class="hideheader"
            :items="data"
            :fields="fields"
            @row-selected="onRowSelected"
          >

          <template v-slot:table-colgroup="scope">
            <col :key="scope.fields.selected" style="width:10%;" >
            <col :key="scope.fields.userName" style="width:30%;" >
            <col :key="scope.fields.modules" style="width:60;" >
          </template>
          
          <template v-slot:cell(userName)="data">
          <b> {{ data.value }}</b>
          </template>

          <template v-slot:cell(modules)="data">
            
          <div v-on:click.stop="clicked(data.index)">
          <b-form-checkbox-group
            :id="'checkbox-group'+data.index"
            :checked="(data.value.trim() != '') ? data.value.split(',') : []"
            :options="options"
            v-on:change="updateUser(data.item,$event)"
            switches
            >
            </b-form-checkbox-group>
            </div> 

          </template>        
          
            <!-- scoped slot for select state -->
          <template v-slot:cell(selected)="{ rowSelected }">
            <template v-if="rowSelected">
              <span> <b-button @click="removeUser" variant="outline-danger"  size="sm" >&#x2717;</b-button></span>
            </template>
            <template v-else>
              <span>&nbsp;</span>
            </template>
          </template>

      </b-table>
    </div>

    </b-card>
    </div>

    <div v-if="dataError">
      <p><b-alert show variant="danger">An error occurred loading data.</b-alert></p>
      <p>{{ error }}</p>
    </div>

        <!-- The modal add user -->
    <b-modal
      :id="'adduser'+this.projectId"
      title="Select User"
      size="md"
      button-size="sm"
      hide-footer
    >
      <AddUser @addUser="addNewUser"> </AddUser>
     
    </b-modal>

   
</div>    
</template>

<script>
import AddUser from "@/components/AddUser.vue";
export default {
  name: "ProjectUsers",
  props: {},
  components: {
      AddUser
  },

  data: function(){
      return{
          projectId: this.$route.params.id, 
          data: [],
          selected: null,
          project: null,
          state: this.$store.state,
          isBusy: true,
          tableIsBusy: false,
          dataError: false,
          error: "",
          fields: [{key:'selected',label:''}, {key: 'userName',label:'Name'}, {key: 'modules',label:'Modules'} ],
          options: [
          { text: 'Journal', value: 'journal' },
          { text: 'PO Viewer', value: 'poviewer' },
          { text: 'Issue Log', value: 'issuelog' },
          { text: 'Photos', value: 'photos' },
          { text: 'PO Item Price', value: 'poprice' }
          ],

      }
  },

  computed: {

  },

  methods: {
    
 fetchData() {
      this.$auth.acquireToken().then(token => {
        Promise.all([
          this.$http.get(
            "api/Project/"  + this.projectId,
            {
              headers: { Authorization: "Bearer " + token }
            }
          ),
          this.$http.get(
            "api/ProjectUsers/" + this.projectId,
            {
              headers: { Authorization: "Bearer " + token }
            }
          )
        ])
          .then(results => {

            if (results[0].status == 204){
              this.dataError = true;
              this.error = "Project " + this.projectId + ": Not found/No user access ";
            }
            else {
             this.data = results[1].data;
             this.project = results[0].data.project;
             this.$store.setItem("project",this.project.projectId + " " + this.project.description);
             this.$store.setItem("projectId", this.project.projectId);
            };

          })
          .catch(error => {
            console.log (error);
            this.dataError = true;
            this.data = [];
            if (error.response) {this.error = error.response.statusText};
          })
          .finally(() => (this.isBusy = false));
      });
    },
    setBreadcrumb() {
      this.$store.setItem("breadcrumbs",[ 
      {
        text: this.projectId,
        to: { name: 'Project', params: { Id: this.projectId } }
      },
      {
        text: 'Project Users'
      }
      ]);
    },
  
    clicked(index){
       if (!this.$refs.usersTable.isRowSelected(index)){
         this.$refs.usersTable.selectRow(index);
       }
       else{
         this.$refs.usersTable.unselectRow(index);
       }
       
    },

    updateUser(user,checked) {

      var lst = checked.join(",");
      user.modules = lst;

      this.tableIsBusy = true;  
      this.$auth.acquireToken().then(token => {
        this.$http
          .put("api/UserProjects", user, {
            headers: { Authorization: "Bearer " + token }
          })
          .then(response => {
 
          })
          .catch(error => {
              console.log(error);
          })
          .finally(() => (
            this.tableIsBusy = false
            ));
      });  

    },

    showModal() {
      this.$bvModal.show("adduser"+this.projectId);
    },

    addNewUser(newUser) {
     
      this.tableIsBusy = true;  
      this.$auth.acquireToken().then(token => {
        this.$http
          .post("api/UserProjects", newUser, {
            headers: { Authorization: "Bearer " + token }
          })
          .then(response => {
            if (response.status == 200){
              this.data.push(newUser)
            };
          })
          .catch(error => {
              console.log(error);
          })
          .finally(() => (
            this.tableIsBusy = false
            ));
      });  
      this.$bvModal.hide("adduser"+this.projectId);
        
    },

    onRowSelected(items){
      this.selected=items[0];
    },

    removeUser() {
      this.tableIsBusy = true;
      this.$auth.acquireToken().then(token => {
        this.$http
          .delete("api/UserProjects/" + this.projectId + "/" + this.selected.userId, {
            headers: { Authorization: "Bearer " + token }
          })
          .then(response => {
            //remove data object
            let i = this.data.findIndex(x => x.userId === this.selected.userId);
            this.data.splice(i, 1);
          })
          .catch(error => {
            console.log(error);
          })
          .finally(() => {
             this.tableIsBusy = false;
          });
      });
  


    }    

  },

activated: function() {
    this.setBreadcrumb();
  },

  mounted: function(){
      this.isBusy = true;
      this.fetchData();
  }
    
}
</script>

<style scoped>

#projectusers {
  max-width: 600px;
  margin: 0 auto;
  padding-top: 5px;
}

</style>

<style>
  .hideheader{
    display: none;
  }
</style>